import { Box, Flex, Image, Text } from '@chakra-ui/react';
import React, { useMemo, useState } from 'react';
import { useUserProvider } from '../../../providers/User/userProvider';
import { useUserEditorProvider } from '../../../providers/UserEditor/userEditorProvider';
import Vendor from '../../../vendor.config';

enum InfoPaneVariant {
	MEDIUM,
	SMALL,
}

export const InfoPane = ({
	topic,
	content,
	isMonetary = false,
	subTopic,
	USDCBalance,
}: {
	topic: string;
	content: string;
	isMonetary?: boolean;
	subTopic?: string;
	USDCBalance?: string;
}) => {
	const { data } = useUserProvider();
	const editorData = useUserEditorProvider();
	const [isUSDC, setIsUSDC] = useState<boolean>(false);

	const typeOptions: any = {
		[InfoPaneVariant.MEDIUM]: () => (
			<>
				<Flex
					color={editorData.color ?? data.color}
					fontSize={{ base: '9px', hashup: '12px' }}
					lineHeight="1.2em"
					mb="6px"
					fontWeight={{ base: '400', hashup: '600' }}
					gridGap={{ base: '0', hashup: '4px' }}
					flexDirection={{ base: 'column', hashup: 'row' }}
				>
					<Text fontWeight="bold">—</Text>
					<Text>{topic}</Text>
				</Flex>
				<Flex
					alignItems="center"
					mb="4px"
				>
					<Text
						fontSize={{ base: '12px', hashup: '18px' }}
						lineHeight={{ base: '15px', hashup: '1.2em' }}
						fontWeight="600"
					>
						{content}
					</Text>
					{isMonetary && (
						<Image
							w={{ base: '11px', hashup: '18px' }}
							h={{ base: '11px', hashup: '18px' }}
							ml="5px"
							src="/icons/hash_logo.svg"
							filter="grayscale(100%)"
						/>
					)}
				</Flex>
				<Text
					fontSize={{ base: '8px', hashup: '14px' }}
					lineHeight={{ base: '10px', hashup: '17px' }}
					letterSpacing=".02em"
					color="#FFFFFF66"
					onMouseOver={() => setIsUSDC(true)}
					onMouseOut={() => setIsUSDC(false)}
				>
					{isUSDC ? USDCBalance : subTopic}
				</Text>
			</>
		),
		[InfoPaneVariant.SMALL]: () => (
			<>
				<Flex alignItems="center">
					<Text
						fontSize={{ base: '12px', hashup: '18px' }}
						lineHeight={{ base: '15px', hashup: '1.2em' }}
						fontWeight="600"
					>
						{content}
					</Text>
					{isMonetary && (
						<Image
							w={{ base: '11px', hashup: '18px' }}
							h={{ base: '11px', hashup: '18px' }}
							ml="5px"
							src={Vendor.gui.asset.logoSmall}
							filter="grayscale(100%)"
						/>
					)}
				</Flex>
				<Flex
					color={data.color}
					fontSize={{ base: '9px', hashup: '12px' }}
					lineHeight="1.2em"
					fontWeight={{ base: '400', hashup: '600' }}
				>
					<Text>{topic}</Text>
				</Flex>
			</>
		),
	};

	const connectType: any = useMemo(() => {
		if (subTopic) {
			return InfoPaneVariant.MEDIUM;
		}
		if (!subTopic) {
			return InfoPaneVariant.SMALL;
		}
	}, [subTopic]);

	return <Box>{typeOptions[connectType]()}</Box>;
};
